module.exports = __webpack_public_path__ + "img/intro-text-image.7e9b24ab.png";